// Types
import type { TAuthStore } from '~/modules/auth/store/types';
import { EFeatureName } from '~/misc/feature/types';
import { EUserRole } from '~/misc/user/types';

// Stores
import { useAuthStore } from '~/modules/auth/store';

export const usePermissions = () => {
  const store: TAuthStore = useAuthStore();

  const isAdmin: ComputedRef<boolean> = computed<boolean>(() => store.role === EUserRole.ADMIN);
  const isOwner: ComputedRef<boolean> = computed<boolean>(() => store.role === EUserRole.OWNER);

  const hasPitchPanelPermission: ComputedRef<boolean> = computed<boolean>(() => {
    return store.features.includes(EFeatureName.PITCH_PANEL) ?? false;
  });

  const hasRoiDashboardPermission: ComputedRef<boolean> = computed<boolean>(() => {
    return store.features.includes(EFeatureName.ROI_DASHBOARD) ?? false;
  });

  const hasUploadDataPermission: ComputedRef<boolean> = computed<boolean>(() => {
    return store.features.includes(EFeatureName.UPLOAD_DATA) ?? false;
  });

  const hasPermissionFor = (feature: EFeatureName): boolean => {
    return store.features.includes(feature);
  };

  return {
    hasPitchPanelPermission,
    hasRoiDashboardPermission,
    hasUploadDataPermission,
    isAdmin,
    isOwner,
    hasPermissionFor,
  };
};
